{
  "id": 1,
  "location": "cafe",
  "difficulty": "easy",
  "moves": 15,
  "kinds": 4,
  "goals": [
    { "type": "collect", "kind": "croissant", "count": 6 }
  ],
  "stars": [10, 20],
  "seed": 1,
  "board": [
    "u l u m m l u u",
    "c m c c l c l l",
    "c l u m c l l u",
    "u m c c l u u m",
    "l c u c u c m m",
    "l m l l u l l u",
    "u l c l c m l m",
    "u c c m m u m m"
  ],
  "calibration": { "runs": 1000, "winRate": 1, "movesLeft": 14, "closeLosses": 0, "target": 0.99 }
}
